<script>
import IsEqual from 'lodash/isEqual'
import _baseDropdownPicker from '../_base-dropdown-picker.vue'
import { getWarrantySyncSearchApi } from '@modules/asset-management/api/warranty-sync-api'

export default {
  name: 'WarrantySyncPicker',
  extends: _baseDropdownPicker,
  props: {
    searchable: { type: Boolean, default: false },
    mandatory: { type: Boolean, default: false },
    onlyEnabledAllowed: { type: Boolean, default: false },
    overlayClassName: {
      type: String,
      default: 'picker-overlay wide-picker-overlay',
    },
    additionalFilters: {
      type: Object,
      default: undefined,
    },
    moduleName: {
      type: String,
      default: undefined,
    },
  },
  data() {
    this.unassignedValue = null
    return {
      warrantySyncs: [],
    }
  },
  computed: {
    options() {
      return this.warrantySyncs
    },
  },
  watch: {
    options: {
      handler(newValue, prevValue) {
        if (!IsEqual(newValue, prevValue)) {
          this.setDefaultValue()
        }
      },
    },
  },
  created() {
    // Build the filter object as per API structure
    const filter = {
      syncFor: this.moduleName
        ? this.moduleName === 'asset'
          ? [this.$constants.ASSET_HARDWARE]
          : [this.moduleName]
        : [this.$constants.ASSET_HARDWARE, this.$constants.CMDB],
    }
    getWarrantySyncSearchApi(filter).then(({ items }) => {
      let options = []
      options = items.map((t) => ({
        ...t,
        text: t.text || t.name,
        key: t.id,
      }))
      this.warrantySyncs = this.onlyEnabledAllowed
        ? options.filter((f) => f.enabled)
        : options
      return this.warrantySyncs
    })
    this.setDefaultValue()
  },
  methods: {
    setDefaultValue() {
      if (!this.value && this.mandatory) {
        let defaultValue = this.options.find((i) => i.primary)
        if (defaultValue) {
          this.$emit('change', defaultValue.key)
        }
      }
    },
  },
}
</script>
